import { render, staticRenderFns } from "./NoticeCreate.vue?vue&type=template&id=79afca16&scoped=true"
import script from "./NoticeCreate.vue?vue&type=script&lang=js"
export * from "./NoticeCreate.vue?vue&type=script&lang=js"
import style0 from "./NoticeCreate.vue?vue&type=style&index=0&id=79afca16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79afca16",
  null
  
)

export default component.exports